export default __webpack_public_path__ + "static/mediaCharThree-d4336e4b807a6d23f13137f64d8cfc5f.png";